<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';
import { useVuelidate } from '@vuelidate/core';

export default {
  components: {
    PageHeader,
    AgentSelector,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      selectedAgents: [],
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
    }),

    branchId() {
      return this.$route.params.branchId;
    },
    headerTitle() {
      return this.$t('BRANCHES_SETTINGS.AGENTS.ADD_TITLE', {
        branchName: this.currentBranch?.name || '',
      });
    },
    currentBranch() {
      return this.$store.getters['branches/getBranch'](this.branchId);
    },
  },

  mounted() {
    this.$store.dispatch('agents/get');
  },

  methods: {
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
    },
    selectAllAgents() {
      this.selectedAgents = this.agentList.map(agent => agent.id);
    },
    async addAgents() {
      this.isCreating = true;
      const { branchId, selectedAgents } = this;

      try {
        await this.$store.dispatch('branchMembers/create', {
          branchId,
          agentsList: selectedAgents,
        });
        router.replace({
          name: 'settings_branches_add_teams',
          params: {
            page: 'new',
            branchId,
          },
        });
        this.$store.dispatch('branches/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-auto">
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="addAgents">
      <PageHeader
        :header-title="headerTitle"
        :header-content="$t('BRANCHES_SETTINGS.AGENTS.HEADER_CONTENT')"
      />

      <div class="w-full h-full">
        <div v-if="v$.selectedAgents.$error">
          <p class="error-message pb-2">
            {{ $t('BRANCHES_SETTINGS.AGENTS.VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :is-working="isCreating"
          :submit-button-text="$t('BRANCHES_SETTINGS.AGENTS.ADD_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
